import { useState } from "react";
import { Toggle } from "Components/Common/ToggleBtn/Toggle";
import { InputField } from "Components/Common/InputField/InputField";
import { errorFormatter } from "Helpers/ErrorMsgHandler";
import { useUploadVisitTypeIcon } from "CustomHooks/useVisitTypes";

export const SettingsTab = ({ visitType, settings, onChange, setApiError }) => {
  const [iconPreview, setIconPreview] = useState(null);

  const uploadIconMutation = useUploadVisitTypeIcon();

  const uploadIcon = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    uploadIconMutation.mutate(formData, {
      onSuccess: (res) => {
        setIconPreview(URL.createObjectURL(file));
        onChange({ ...settings, icon: res?.key });
      },
      onError: (err) => {
        setApiError(errorFormatter(err?.response?.data?.errors || err?.message));
      },
    });
  };

  return (
    <div className="space-y-6 max-w-2xl">
      <div className="bg-white border border-gray-200 rounded-lg p-4 space-y-4">
        <InputField
          id="settings-name"
          label="Name"
          isRequired
          value={settings.name}
          onChange={(value) => onChange({ ...settings, name: value })}
        />
        <div>
          <label className="block text-sm font-semibold text-gray-700">Description</label>
          <textarea
            rows={2}
            className="mt-1 block w-full px-2 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none sm:text-sm"
            value={settings.description || ""}
            onChange={({ target }) => onChange({ ...settings, description: target.value })}
          />
        </div>
        <div>
          <label className="block text-sm font-semibold text-gray-700">Icon</label>
          <div className="mt-1 flex items-center gap-4">
            {(iconPreview || visitType?.iconUrl) ? (
              <img
                src={iconPreview || visitType.iconUrl}
                alt="icon"
                className="h-12 w-12 rounded object-cover border border-gray-200"
              />
            ) : settings.icon ? (
              <div className="h-12 w-12 rounded border border-gray-200 bg-gray-50 flex items-center justify-center text-gray-400 text-xl">
                🖼
              </div>
            ) : null}
            <div>
              <label className="cursor-pointer inline-block text-sm text-blue-chill border border-blue-chill rounded-md px-3 py-2 hover:bg-gray-50">
                {uploadIconMutation.isLoading
                  ? "Uploading…"
                  : settings.icon
                  ? "Replace icon"
                  : "Upload icon"}
                <input type="file" accept="image/*" className="hidden" onChange={uploadIcon} />
              </label>
              <p className="text-xs mt-1 text-gray-500">
                {settings.icon ? (
                  <>
                    Attached:{" "}
                    <span className="font-mono">
                      {settings.icon.split("/").pop().replace(/^\d+-/, "")}
                    </span>
                  </>
                ) : (
                  "No icon uploaded yet."
                )}
              </p>
            </div>
          </div>
          <p className="text-xs text-gray-500 mt-1">
            Uploads immediately; remember to Save Draft to attach it to the type.
          </p>
        </div>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg divide-y divide-gray-100">
        <div className="p-4 flex items-center justify-between">
          <div>
            <div className="text-sm font-medium text-gray-900">Allow free-text reason</div>
            <div className="text-xs text-gray-500">
              Let the patient type their own reason for the visit in addition to
              the questionnaire.
            </div>
          </div>
          <Toggle
            enabled={settings.allowFreeTextReason}
            onChange={() =>
              onChange({ ...settings, allowFreeTextReason: !settings.allowFreeTextReason })
            }
          />
        </div>
      </div>

      <p className="text-xs text-gray-500">
        Slug: <span className="font-mono">{visitType?.slug}</span> (permanent) ·
        Activation and deletion live on the Visit Types list page. Which doctors
        receive each visit type is managed per doctor in Provider access
        (state restrictions / access levels).
      </p>
    </div>
  );
};
